var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"300px","height":"300px"},attrs:{"id":_vm.divid}})])}
var staticRenderFns = []

export { render, staticRenderFns }